import { formatReferenceCopy } from 'utils/typography'
import {
  useTranslation,
} from 'react-i18next'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'

const ManagerExecutorFields = ({
  app,
  executorId,
  onExecutorIdChange,
  executorChangeReason,
  onExecutorChangeReasonChange,
  companyOptions,
  denseTop = false,
}: ApplicationManagerExecutorFieldsProps & { denseTop?: boolean }) => {
  const { t } = useTranslation()
  const savedExecutorId = app.executor_company_id ?? null
  const draftExecutorId = executorId === '' ? null : Number(executorId)
  const isExecutorChangeFromSaved = savedExecutorId !== null
    && draftExecutorId !== null
    && draftExecutorId !== savedExecutorId

  return (
    <>
      <FormControl fullWidth size='small' sx={{ marginTop: denseTop ? 0 : 2 }}>
        <InputLabel shrink>
          <Typography component='span' variant='inherit' color='text.primary'>
            {formatReferenceCopy(t('applications__text__executor'))}
          </Typography>
        </InputLabel>
        <Select
          label={formatReferenceCopy(t('applications__text__executor'))}
          value={executorId === '' ? '' : String(executorId)}
          onChange={(e) => {
            const nextId = Number(e.target.value)
            onExecutorIdChange(nextId)
            if (savedExecutorId !== null && nextId === savedExecutorId) {
              onExecutorChangeReasonChange('')
            }
          }}
        >
          {companyOptions.map((c) => (
            <MenuItem key={c.id} value={String(c.id)}>
              <Typography component='span' variant='inherit'>{formatReferenceCopy(c.name)}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {isExecutorChangeFromSaved && (
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          size='small'
          required
          multiline
          minRows={3}
          sx={{ marginTop: 2 }}
          label={<Typography component='span' variant='inherit' color='text.primary'>
            {formatReferenceCopy(t('applications__text__changeReason'))}
          </Typography>}
          value={executorChangeReason}
          onChange={(e) => onExecutorChangeReasonChange(e.target.value)}
        />
      )}
    </>
  )
}

export function managerExecutorSelectionInvalid({
  app,
  executorId,
  executorChangeReason,
}: ApplicationManagerExecutorSelectionInvalidArgs): boolean {
  if (executorId === '') {
    return true
  }
  const savedExecutorId = app.executor_company_id ?? null
  const draftExecutorId = Number(executorId)
  const isExecutorChangeFromSaved = savedExecutorId !== null
    && draftExecutorId !== savedExecutorId
  if (isExecutorChangeFromSaved && !executorChangeReason.trim()) {
    return true
  }
  return false
}

export default ManagerExecutorFields
